import React from 'react'
import { Layout } from '../layouts/Layout';
import { NonCashMethodData } from '../componen/NonCashMethodData'

export const NonCashMethodPages = () => {
  return (
    <Layout>
      <NonCashMethodData />
    </Layout>
  )
}
